export default "__VITE_ASSET__CwPy5119__"